import { Controller } from 'stimulus'
import { googleAnalytics3Event } from 'lib/googleAnalytics3'

export default class extends Controller {
  static values = {
    campaign: String,
    uri: String
  }

  logClickEvent () {
    googleAnalytics3Event({
      eventAction: 'Elements Click',
      eventCategory: this.campaignValue,
      eventLabel: this.uriValue
    })
  }
}
